import React from "react"

import { Avatar } from "@mui/material"
import { Edit } from "@mui/icons-material"

import Dropzone from "react-dropzone"

interface CustomDropzoneProps
{
    logoImg: string | undefined
    callback: (logo: FormData | null) => void
}
interface CustomDropzoneState
{
    logoImg?: string | null
}
export class CustomDropzoneLogo extends React.Component<CustomDropzoneProps, CustomDropzoneState>
{
    constructor(props: CustomDropzoneProps)
    {
        super(props)
        this.state = {
            logoImg: null,
        }
    }

    componentDidMount()
    {
        this.setState(() => ({logoImg: this.props.logoImg}))
    }

    private onDrop = (acceptedFiles: File[]) => {
        const formData: FormData = new FormData()

        formData.append("file", acceptedFiles[0])

        this.setState(() => ({
            logoImg: URL.createObjectURL(acceptedFiles[0]),
        }), () => (this.props.callback(formData as FormData)))
    }

    render()
    {
        return (
            <Dropzone onDrop={this.onDrop}>
                {({getRootProps, getInputProps, open}) => (
                    <section style={{display: "flex", justifyContent: "center", marginLeft: "16px"}}>
                        <div {...getRootProps({className: "dropzone"})}>
                            <input {...getInputProps()} />
                            {this.state.logoImg &&
                                <img src={this.state.logoImg} alt="logo img" width={150} height={150} style={{borderRadius: 80}}/>
                            }
                            {!this.state.logoImg &&
                                <div style={{padding: "16px"}}>
                                    <Avatar sx={{width: 134, height: 134}}>No logo</Avatar>
                                </div>
                            }
                        </div>
                        <Edit color="secondary" sx={{marginTop: "16px", marginLeft: "-16px"}} onClick={open} />
                    </section>
                )}
            </Dropzone>
        )
    }
}
